(function() {
  if (typeof gsap === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var overlay = document.getElementById('page-transition-overlay');
  if (!overlay) return;

  // Build logo element inside overlay
  var logo = document.createElement('div');
  logo.style.cssText = [
    'font-family: var(--font-heading)',
    'font-size: 14px',
    'letter-spacing: 4px',
    'color: #C9A84C',
    'opacity: 0',
    'text-align: center',
    'pointer-events: none'
  ].join(';');
  logo.textContent = 'PRO ART CARTRIDGE';
  overlay.appendChild(logo);

  // Enable pointer events only when active
  overlay.style.pointerEvents = 'none';

  function enterPage() {
    // Slide overlay out upward on new page entry
    gsap.set(overlay, { y: '0%' });
    gsap.to(overlay, {
      y: '-100%',
      duration: 0.6,
      ease: 'power2.inOut',
      delay: 0.1,
      onStart: function() { overlay.style.pointerEvents = 'none'; }
    });
    gsap.to(logo, { opacity: 0, duration: 0.2 });
  }

  // Intercept internal link clicks
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a');
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href) return;
    // Skip: external links, anchors, mailto, tel, target="_blank"
    if (
      href.startsWith('#') ||
      href.startsWith('http') ||
      href.startsWith('//') ||
      href.startsWith('mailto') ||
      href.startsWith('tel') ||
      link.target === '_blank' ||
      e.metaKey || e.ctrlKey || e.shiftKey
    ) return;

    e.preventDefault();
    overlay.style.pointerEvents = 'auto';

    gsap.set(overlay, { y: '100%' });
    gsap.to(overlay, {
      y: '0%',
      duration: 0.5,
      ease: 'power2.in',
      onComplete: function() {
        gsap.to(logo, {
          opacity: 1,
          duration: 0.3,
          onComplete: function() {
            window.location.href = href;
          }
        });
      }
    });
  });

  // On page show (handles back/forward cache too)
  window.addEventListener('pageshow', function(e) {
    // Always run on page entry — covers initial load and bfcache restore
    enterPage();
  });
})();
